/**
 * Firestore-related constants
 */

// Firestore 'in' and 'array-contains-any' query limit
export const FIRESTORE_IN_QUERY_LIMIT = 30;

// Firestore batch write limit
export const FIRESTORE_BATCH_WRITE_LIMIT = 500;
